<template v-if="item" src="./html/Edit.html"></template>

<script>
	import swal from 'sweetalert2'
	import Ladda from 'ladda'
	import Multiselect from 'vue-multiselect'

	import Availability from './../../projects/availability/layout/Availability.vue'
	import PlaceEdit from './../../projects/places/views/Edit.vue'
	import ChangePassword from './ChangePassword.vue'
	import Dropzone from 'vue2-dropzone'

	export default {
		props: ['user', 'isAuth'],
		components: {
			'multiselect': Multiselect,
			'availability': Availability,
			'place-edit': PlaceEdit,
			'change-password': ChangePassword,
			'dropzone': Dropzone,
		},
		created () {
			if(this.user.hasRole(['manager', 'admin'])) {
				this.init()
			}
		},
		data () {
			return {
				item: null,
				resource: null,
				roles: null,
				statuses: null,
				departments: null,

				dropzone: {
					headers: {
						'Authorization': 'Bearer ' + this.$auth.getToken(),
						'account': this.$platform.slug,
					},
					accepted: this.$env.ACCEPTED_DROPZONE_IMAGES,
					url: null,
					maxFileSizeInMB: 20,
					maxNumberOfFiles: 1,
				},
			}
		},
		methods: {
			init() {
				this.getData()
				this.getDepartments()
				this.getRoles()
				this.getStatuses()
			},
			changeAvailable(available) {
				if(this.item.profile.available == 0) {
					this.$refs.staffComments.openCommentsCreate()
				}
			},
			reload() {
				this.getData()
			},
			getStatuses() {
				this.$http.get('admin/statuses')
				.then(response => {
					this.statuses = response.body
				}).catch(function(response) {
					console.log(response)
				})
			},
			getDepartments() {
				this.$http.get('admin/departments')
				.then(response => {
					this.departments = response.body
				}).catch(function(response) {
					console.log(response)
				})
			},
			getRoles() {
				this.$http.get('admin/roles')
				.then(response => {
					this.roles = response.body
				}).catch(function(response) {
					console.log(response)
				})
			},
			getData() {
				this.$http.get('admin/users/' + this.$route.params.id + '/edit')
				.then(response => {
					this.item = response.body.user
					this.resource = 'admin/users/' + this.item.id
					this.dropzone.url = process.env.ROOT + '/api/' + this.$lang.getLang() + '/admin/users/' + this.item.id + '/avatar'
				}).catch(function(response) {
					console.log(response)
				})
			},
			update() {
				var loading = Ladda.create(this.$refs.btnUpdate)
				loading.start()
				if(this.department) {
					this.item.department_id = this.department.id
				}
				this.$http.put('admin/users/' + this.item.id, this.item)
				.then(response => {
					var menu = this.$route.meta.menu
					if(menu == 'dashboard') {
						this.$router.push('/' + this.$i18n.locale + '/' + this.$platform.slug + '/admin/users')
					} else {
						this.$router.push('/' + this.$i18n.locale + '/' + this.$platform.slug + '/admin/' + menu + '/users')
					}
					loading.stop();
					swal({
						title: response.body.title,
						text: response.body.text,
						type: response.body.type,
					})
				}).catch(function(response) {
					console.log(response)
					loading.stop();
					swal({
						title: response.statusText,
						text: response.body,
						type: "warning",
					})
				})
			},
			dropzoneSuccess(response, file) {
				this.reload()
			},
			destroyAvatar() {
				var that = this
				swal.queue([{
					title: that.$t("messages.attention"),
					text: that.$t("messages.item_can_not_be_retrieved"),
					type: "warning",
					showCancelButton: true,
					confirmButtonColor: "#53e69d",
					cancelButtonColor: "#ff7676",
					confirmButtonText: "Si",
					cancelButtonText: "No",
					showLoaderOnConfirm: true,
					preConfirm: function () {
						return new Promise(function (resolve) {
							that.$http.delete('admin/users/' + that.item.id + '/avatar')
							.then(response => {
								that.reload()
								swal(response.body.title, response.body.text, response.body.type);
							}).catch(function(response) {
								if(response.status == 409) {
									swal(response.body.title, response.body.text, response.body.type);
								} else {
									swal({
										title: response.statusText,
										text: response.body,
										type: "warning"
									});
								}
							})
						})
					}
				}]).catch(swal.noop)
			}
		}
	}	
</script>


// WEBPACK FOOTER //
// src/components/users/views/Edit.vue